if (!customElements.get('cc-room-occasion')) {
  customElements.define('cc-room-occasion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.selector = this.querySelector('[data-room-occasion]');
      this.panel = this.querySelector('[data-room-quote-panel]');
      this.picker = document.querySelector('main variant-picker[data-product-handle="occasion-room-styling"]');
      if (!this.selector || !this.panel || !this.picker) return;
      document.body.classList.add('cc-room-occasion-ready');
      this.selector.addEventListener('change', () => this.changeOccasion(), { signal });
      // Block any stale product-form submission while the page is in quote mode.
      document.addEventListener('submit', event => {
        if (!document.body.classList.contains('cc-room-quote')) return;
        const form = event.target;
        if (form instanceof HTMLFormElement && form.action.includes('/cart/add')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[name="contact[body]"]')?.focus();
        }
      }, { capture: true, signal });
      if (['custom', 'other'].includes(new URL(location.href).searchParams.get('occasion'))) {
        this.selector.value = '__custom__';
      }
      this.setMode(this.selector.value === '__custom__');
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.body.classList.remove('cc-room-occasion-ready', 'cc-room-quote');
    }
    setMode(isQuote) {
      document.body.classList.toggle('cc-room-quote', isQuote);
      this.panel.hidden = !isQuote;
      // Inactive quote fields must not participate in validation or autofill.
      for (const field of this.panel.querySelectorAll('input,select,textarea,button')) {
        field.disabled = !isQuote;
      }
    }
    changeOccasion() {
      const isQuote = this.selector.value === '__custom__';
      this.setMode(isQuote);
      const url = new URL(location.href);
      if (isQuote) {
        url.searchParams.set('occasion', 'custom');
        history.replaceState({}, '', url);
        this.querySelector('[name="contact[body]"]')?.focus();
        return;
      }
      url.searchParams.delete('occasion');
      history.replaceState({}, '', url);
      const radio = [...this.picker.querySelectorAll('input[data-option-name="Occasion"]')]
        .find(input => input.value === this.selector.value);
      if (radio) {
        radio.click();
      } else {
        const select = this.picker.querySelector('select[name="options[Occasion]"]');
        if (select) {
          select.value = this.selector.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });
}
